import React, {useEffect, useState, useCallback } from "react";
import {eventGoogleAnalytics} from "../registration/analytics";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";


const Acquiring = ({firstPrice, subPrice, email = '', doneMark = true}) => {

    const translation = useTranslation('mainPage');
    /** @type {any} */
    const t = translation.t;
    
    const navigate = useNavigate();

    const [agreeWithdraw, setAgreeWithdraw] = useState(false);
    const [agreeOffer, setAgreeOffer] = useState(false);

    const [userEmail, setUserEmail] = useState(email);


    useEffect(() => {
        if (email === '') {
            const id = localStorage.getItem('userID');
            if (id) setUserEmail(id);
        } else {
            setUserEmail(email);
        }
    }, [email]);



    const handlePayment = useCallback(() => {
        /** @type {{ charge: Function }} */
        const widget = new window.cp.CloudPayments({
            language: "ru-RU",
            email: email || '',
            applePaySupport: false,
            googlePaySupport: false,
            yandexPaySupport: false,
            tinkoffPaySupport: true,
            tinkoffInstallmentSupport: false,
            sbpSupport: true,
        });

        const receipt = {
            Items: [
                {
                    label: t("Payment.Label"),
                    price: firstPrice,
                    quantity: 1.0,
                    amount: firstPrice,
                    vat: 0,
                    method: 0,
                    object: 0,
                },
            ],
            taxationSystem: 0,
            ...(email ? { email } : {}),
            phone: "",
            isBso: false,
            amounts: {
                electronic: firstPrice,
                advancePayment: 0.0,
                credit: 0.0,
                provision: 0.0,
            },
        };

        const receiptRecurrent = {
            Items: [
                {
                    label: t("Payment.Label"),
                    price: subPrice,
                    quantity: 1.0,
                    amount: subPrice,
                    vat: 0,
                    method: 0,
                    object: 0,
                },
            ],
            taxationSystem: 0,
            ...(email ? { email } : {}),
            phone: "",
            isBso: false,
            amounts: {
                electronic: subPrice,
                advancePayment: 0.0,
                credit: 0.0,
                provision: 0.0,
            },
        };

        const date = new Date();
        date.setDate(date.getDate() + parseInt(localStorage.getItem('period')));

        const data = {
            CloudPayments: {
                CustomerReceipt: receipt,
                recurrent: {
                    interval: "Month",
                    period: localStorage.getItem('tariff'),
                    customerReceipt: receiptRecurrent,
                    startDate: date
                },
            },
        };

        widget.charge(
            {
                publicId: "pk_4a8b35334f78ae1f4ca1dbd3650c4",
                description: t("Payment.Description"),
                amount: firstPrice,
                currency: "RUB",
                // accountId: String(userEmail),
                accountId: email || 'server@team.usafe.ru',
                invoiceId: String(localStorage.getItem('userPayToken')),
                data: data,
            },
            function () {
                eventGoogleAnalytics("purchase", "shop", "purchase", firstPrice);
                localStorage.setItem('payment', 'completed')
                if (email === '') {
                    navigate(`/instantLogin`);
                } else {
                    window.location.reload();
                }

            },
            function (reason) {
                // toast.error(reason);
            }
        );
    }, [email, t, firstPrice, subPrice, navigate]);

    useEffect(() => {
        if (
            // (localStorage.getItem('subscriptionIsActive') === 'false' || localStorage.getItem('userID')) &&
            localStorage.getItem('userID') &&
            // todo Вернуть открывание эквайринга в профиле
            firstPrice != null &&
            subPrice != null &&
            userEmail &&
            localStorage.getItem('i') &&
            localStorage.getItem('j') &&
            typeof window.cp !== "undefined"
        ) {
            const referrer = document.referrer;
            if (referrer.includes('https://widget.cloudpayments.ru')) {
                navigate(`/instantLogin`);
            } else {
                localStorage.setItem('userPayToken', localStorage.getItem('userID'));
                handlePayment();
            }
        }
    }, [firstPrice, handlePayment, navigate, subPrice, userEmail]);

    const checkboxesAccepted = agreeWithdraw && agreeOffer;

    return (
        <>
            {(!localStorage.getItem('i') && !localStorage.getItem('j') && doneMark) && (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    justifyContent: "start",
                    gap: "15px",
                    fontSize: "0.75em"
                }}>
                    <label style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "start",
                        justifyContent: "start",
                        gap: "10px",
                        padding: '0 10px 0 0',
                        boxSizing: "border-box"
                    }}>
                        <input
                            type="checkbox"
                            checked={agreeWithdraw}
                            onChange={() => setAgreeWithdraw(!agreeWithdraw)}
                        />
                        <span>
                            даю согласие на автоматические списания с первым платежом через 30 дней в размере 150 рублей в месяц
                        </span>
                    </label>
                    <label style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "start",
                        justifyContent: "start",
                        gap: "10px",
                        padding: '0 10px 0 0',
                        boxSizing: "border-box"
                    }}>
                        <input
                            type="checkbox"
                            checked={agreeOffer}
                            onChange={() => setAgreeOffer(!agreeOffer)}
                        />
                        <span className="offer-style-text-2">
                            принимаю, что ознакомлен с условиями{' '}
                            <span
                                style={{cursor: 'pointer', textDecoration: 'underline'}}
                                onClick={() => navigate('/offer')}
                            >
                                оферты
                            </span>
                        </span>
                    </label>
                </div>
            )}

            <button
                className="button-user-console-main"
                onClick={() => {
                    localStorage.setItem('userPayToken', localStorage.getItem('userID'));
                    handlePayment();
                }}
                disabled={(!checkboxesAccepted && (!localStorage.getItem('i') || !localStorage.getItem('j'))) && doneMark}
            >
                Купить
            </button>
        </>
    );
};

export default Acquiring;
